import React from 'react';

import { Home } from '../../../modules/home';

export function HomePage() {
	return <Home />;
}
